<script setup lang="ts">
type Props = {
  fluid?: boolean,
};

const props = defineProps<Props>();
</script>
<template>
  <div class="flex flex-col gap-2" :class="{'w-full': props.fluid}">
    <slot />
  </div>
</template>
